import { getDictList } from '@/api/db'
import { setToken, getToken } from '@/libs/util'
export default {
    state: {
        token: getToken(),
        userName: '',
        userId: '',
        avatorImgPath: '',
        access: '',
        //dictList:{},
    },
    mutations: {
        setAvator(state, avatorPath) {
            state.avatorImgPath = avatorPath
        },
        setUserId(state, id) {
            state.userId = id
        },
        setUserName(state, name) {
            state.userName = name
        },
        setToken (state, token) {
            state.token = token
            setToken(token)
        },
        // setDictList(state,data){
        //     state.dictList = data
        // },
        
    },
    actions: {
        handleLogin({ commit }, { mobile, password }) {
            mobile = mobile.trim();
            // return new Promise((resolve, reject) => {
            //     login({
            //         mobile,
            //         password
            //     }).then(res => {
            //         const data = res.data
            //         commit('setToken', data.access_token) 
            //         resolve();
            //     }).catch(err => {
            //         reject(err)
            //     })
            // })
        },
        //获取用户基础信息
        getUserInfo({ state, commit}){
            // return new Promise((resolve, reject) => {
            //     try {
            //       getUserInfo(state.token).then(res => {
            //         const data = res.data
            //         commit('setAvator', data.avator)
            //         commit('setUserName', data.name)
            //         commit('setUserId', data.user_id)
            //         commit('setAccess', data.access)
            //         commit('setHasGetInfo', true)
            //         resolve(data)
            //       }).catch(err => {
            //         reject(err)
            //       })
            //     } catch (error) {
            //       reject(error)
            //     }
            // })
        },
        //查询字典值列表
        // getDictList ({ commit }) {
        //     let dictList = this.state.user.dictList
        //     if(Object.keys(dictList).length != 0){
        //         return this.state.user.dictList
        //     }else{
        //         return getDictList().then(resp=>{
        //             const data = resp.data
        //             commit('setDictList',data) 
        //             return resp.data
        //         })
        //     }    
        // },
    }
}


// WEBPACK FOOTER //
// ./src/store/module/user.js